var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BannerTextComponent"},[_c('v-img',{attrs:{"src":_vm.image,"width":"100%","height":_vm.height,"content-class":"message"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }